<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{ aLang.c_list }} quảng cáo
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form ref="myForm" label-position="top" @submit.native.prevent
                :model="mData.tableRules.dataSearch.value" :rules="mData.tableRules.dataSearch.valid">
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Tên người đăng ký" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['thong_tin.ten']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Tên doanh nghiệp" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['thong_tin.ten_cong_ty']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Ngành nghề" prop="">
                      <el-input v-model="mData.tableRules.dataSearch.value['thong_tin.nganh_nghe']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Sản phẩm chính">
                      <el-input v-model="mData.tableRules.dataSearch.value['thong_tin.san_pham_chinh']" clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)">
                      </el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button type="info" native-type="submit" v-ladda plain @click="fn_tableSearch()">{{
                    aLang.c_search
                  }}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{ aLang.c_showHideSearch }}</el-button>
              <!-- <el-button @click="fn_handle('create')" v-if="mData.ifHaveCreate" type="info" plain>{{aLang.c_create}}</el-button> -->
            </div>
          </b-col>
        </b-row>
        <el-table :data="mData.tableRules.data" border @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange" max-height="440" style="width: 100%"
          :default-sort="{ prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1] }">
          <!-- <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column> -->
          <el-table-column label="STT" width="45">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="thong_tin.ten" label="Tên người đăng ký" :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <el-link class="cell-child" target="_blank" @click="fn_handle('detail', scope.$index, scope.row)"
                :underline="false">{{ scope.row.thong_tin.ten }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="thong_tin.ten_cong_ty" label="Tên doanh nghiệp"
            :sortable="mData.tableRules.allowSorting">
          </el-table-column>
          <el-table-column prop="thong_tin.email" label="Email" width="120px">
          </el-table-column>
          <el-table-column prop="thong_tin.nganh_nghe" label="Ngành nghề" width="120px">
          </el-table-column>
          <el-table-column prop="thong_tin.san_pham_chinh" label="Sản phẩm chính" width="130px">
          </el-table-column>
          <el-table-column prop="vi_tri.trang" label="Màn hình hiển thị" width="130px">
            <template slot-scope="scope">
              <div class="text-center">
                {{
                  scope.row.vi_tri.trang === "TrangChu" ? 'Trang chủ' :
                    scope.row.vi_tri.trang === "GioiThieu" ? 'Giới thiệu' :
                      scope.row.vi_tri.trang === "DiemDen" ? 'Điểm đến' :
                        scope.row.vi_tri.trang === "ChiTietDiemDen" ? 'Chi tiết điểm đến' :
                          scope.row.vi_tri.trang === "Tour" ? 'Tour' :
                            scope.row.vi_tri.trang === "ChiTietTour" ? 'Chi tiết tour' :
                              scope.row.vi_tri.trang === "LuuTru" ? 'Lưu trú' :
                                scope.row.vi_tri.trang === "ChiTietLuuTru" ? 'Chi tiết lưu trú' :
                                  scope.row.vi_tri.trang === "AmThuc" ? 'Ẩm thực' :
                                    scope.row.vi_tri.trang === "ChiTietAmThuc" ? 'Chi tiết ẩm thực' :
                                      scope.row.vi_tri.trang === "GiaiTri" ? 'Giải trí' :
                                        scope.row.vi_tri.trang === "ChiTietGiaiTri" ? 'Chi tiết giải trí' :
                                          scope.row.vi_tri.trang === "VeDienTu" ? 'Vé điện tử' :
                                            scope.row.vi_tri.trang === "TinTuc" ? 'Tin tức' :
                                              scope.row.vi_tri.trang === "ChiTietTinTuc" ? 'Chi tiết tin tức' : ''
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="vi_tri.vi_tri_trang" label="Vị trí hiển thị" width="120px"
            :sortable="mData.tableRules.allowSorting">
            <template slot-scope="scope">
              <div class="text-center">
                {{
                  scope.row.vi_tri.vi_tri_trang === "ViTri1" ? 'Vị trí 1' :
                    scope.row.vi_tri.vi_tri_trang === "ViTri2" ? 'Vị trí 2' :
                      scope.row.vi_tri.vi_tri_trang === "ViTri3" ? 'Vị trí 3' :
                        scope.row.vi_tri.vi_tri_trang === "ViTri4" ? 'Vị trí 4' :
                          scope.row.vi_tri.vi_tri_trang === "ViTri5" ? 'Vị trí 5' :
                            scope.row.vi_tri.vi_tri_trang === "ViTri6" ? 'Vị trí 6' : ""
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="hien_thi" label="Trạng thái hiển thị" width="130px">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.hien_thi === true ? 'Hiển thị' : "Không hiển thị" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="trang_thai" label="Trạng thái" :sortable="mData.tableRules.allowSorting" width="110">
            <template slot-scope="scope">
              <div class="text-center">
                {{ scope.row.trang_thai === 0 ? 'Đã duyệt' : scope.row.trang_thai === 1 ? 'Chờ duyệt' : 'Từ chối' }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="135px">
            <template slot-scope="scope">
              <el-button size="mini" @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail">
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update">
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button size="mini" @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete">
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">{{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination @size-change="fn_tableSizeChange" @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick" @next-click="fn_tableNextClick" :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit" :current-page="mData.tableRules.page" background
              layout="total, sizes, prev, pager, next, jumper" :total="mData.tableRules.total"
              :pager-count="5"></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from '@/service/DataService';
import QuangCaoApi from '../../../moduleApi/QuangCaoApi';
import MethodService from '../../../service/MethodService';
import QuangCaoModel from './QuangCaoModel';
import ExtensionService from '@/service/ExtensionService';
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        viewMode: "detail",
        moduleName: "QuangCao", //requied
        dataForm: MethodService.copyObject(QuangCaoModel.dataForm),
        tableRules: MethodService.copyObject(QuangCaoModel.tableRules),
        validForm: MethodService.copyObject(QuangCaoModel.validForm),
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        fileUploadOption: MethodService.copyObject(
          QuangCaoModel.dataFormOther.fileUploadOption
        ),
        ifHavePermission: false,
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
        }
      }
    }
  },
  created() {
    this.fn_hashUrl();
    this.getQuangCaoList();
  },
  methods: {
    async getQuangCaoList() {
      let dataFilter = {
        filters: this.mData.tableRules.filters + "&trang_thai=0|trang_thai=2"
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch
            }
          })
          .catch(() => { });
      }

      let res = await QuangCaoApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);
      for (const element of res.result) {
        if (element.vi_tri == undefined) {
          element.vi_tri = { trang: null, vi_tri_trang: null };
        }
        if (element.thong_tin.mediaId) {
          let data = {
            id: element.thong_tin.mediaId,
            name: element.thong_tin.mediaId,
            url: ExtensionService.urlImg + element.thong_tin.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
      }


      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getQuangCaoList();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getQuangCaoList();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getQuangCaoList();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getQuangCaoList();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },
    fn_formatterDatetimeList(cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
    fn_handle(type, scope, row) {
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_delete(row.id);
        }).catch(() => { });
      }
    },

    async fn_delete(id) {
      await QuangCaoApi.delete(id);
      this.getQuangCaoList();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  }
}
</script>

<style scope>
.el-button+.el-button {
  margin-left: 5px;
}
</style>
